import {Component, OnInit, Inject} from '@angular/core';
import {MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import {MasterService} from './../../home/services/master.service';
import {CommonAlertService} from './../../services/common-alert.service';

@Component({
  selector: 'app-change-password-modal',
  templateUrl: './change-password-modal.component.html',
  styleUrls: ['./change-password-modal.component.scss']
})
export class ChangePasswordModalComponent implements OnInit {

  curPassword: any;
  newPassword: any;
  confNewPassword: any;
  formValidation: boolean;
  errorMsg: any;

  // tslint:disable-next-line:max-line-length
  constructor(public masterService: MasterService, public dialogRef: MatDialogRef<ChangePasswordModalComponent>, public commonAlertService: CommonAlertService) {
  }

  ngOnInit() {
  }

  submitForm() {
    // tslint:disable-next-line:indent
    if (this.newPassword === this.confNewPassword) {
      // tslint:disable-next-line:variable-name
      const form_data = {};
      Object.assign(form_data, {
        token: localStorage.getItem('token'),
        password: this.curPassword,
        newPassword: this.newPassword
      });
      this.masterService.addEditRecord(form_data, '/profile/update_profile_password').subscribe(res => {
        // @ts-ignore
        if (res.success) {
          this.close();
          this.commonAlertService.showEdit({message: 'Password updated successfully'});
        }
      }, err => {
        if (err) {
          this.errorMsg = 'Current password is wrong.';
          this.formValidation = true;
        }
      });
    } else {
      this.errorMsg = 'New password and Confirm password doesn\'t match';
      this.formValidation = true;
    }
  }

  close() {
    this.dialogRef.close();
  }

}
